<template>
    <div class="home-evaluation-form">
        <div class="home-evaluation-form-content">
            <!-- 1、输入昵称 -->
            <div class="home-evaluation-item dsp-flex">
                <div class="home-evaluation-label">主人昵称：</div>
                <div class="home-evaluation-content">
                    <input class="home-evaluation-input" v-model="userInfo.f_name" type="text" @blur="blurInput" placeholder="请输入">
                </div>
            </div>
            <!-- 2、输入性别 -->
            <div class="home-evaluation-item dsp-flex">
                <div class="home-evaluation-label">性<i class="label-two"></i>别：</div>
                <div class="home-evaluation-content">
                    <span class="home-evaluation-sex-item" @click="selectSex(0)"><i class="iconbg icon-sex" v-bind:class="{'icon-nosex': userInfo.sex == 1, 'icon-s-male': userInfo.sex == 0}"></i>男</span>
                    <span class="home-evaluation-sex-item" @click="selectSex(1)"><i class="iconbg icon-sex" v-bind:class="{'icon-nosex': userInfo.sex == 0, 'icon-s-female': userInfo.sex == 1}"></i>女</span>
                </div>
            </div>
            <!-- 3、输入出生地点 -->
            <div class="home-evaluation-item dsp-flex">
                <div class="home-evaluation-label">出生地点：</div>
                <div class="home-evaluation-content home-evaluation-content-birthday" @click="clickArea">
                    <p v-if="areaStr == ''" class="home-evaluation-time-placehold">非必选(选了会自动计算时差更精准)</p>
                    <p v-else class="home-evaluation-time">{{areaStr}}</p>
                </div>
            </div>
            <!-- 4、输入出生时间 -->
            <div class="home-evaluation-item dsp-flex">
                <div class="home-evaluation-label">出生时间：</div>
                <div class="home-evaluation-content home-evaluation-content-birthday" @click="clickBirthday">
                    <p v-if="birthdayStr == ''" class="home-evaluation-time-placehold">请输入(国内外皆以当地时间为准)</p>
                    <p v-else class="home-evaluation-time">{{birthdayStr}}</p>
                </div>
            </div>
        </div>
        <div class="home-evaluation-button-box">
            <button id="homeButton" class="home-ebb-button" @click="clickStart">智能测测</button>
        </div>

    </div>
</template>

<script>
import { UA } from '../../modules/utils';
import { DOM, LOADING_DOM } from '../../modules/dom'; 
import { FORMAT } from '../../modules/data/core/format';
export default {
    name: 'HomeEvaluationForm',
    computed: {
        areaStr() {
            return this.$store.state.user.areaStr;
        },
        birthdayStr() {
            return this.$store.state.user.birthdayStr;
        },
        userInfo() {
            return this.$store.state.user.strongUserInfo;
        }
    },
    data() {
        return {
            startLocked: false
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.startLocked = false;
            LOADING_DOM.hideLoading();
        }, 20);
    },
    methods: {
        selectSex(value) {
            this.$store.state.user.strongUserInfo.sex = value;
        },
        /**
         * 点击输入，弹出输入生日弹框
         */
        clickBirthday() {
            this.$store.state.strong.showStrongBirthdayPop = true;
        },
        blurInput() {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 20);
        },
        clickArea() {
            this.$store.state.strong.showStrongAreaPop = true;
        },
        clickStart() {
            if(this.startLocked) {
                return;
            }
            let formData = Object.assign(this.userInfo);
            // 检查输入:时间
            if(formData.birthday == '') {
                this.$toast.setDefaultOptions({position: 'middle'});
                this.$toast('请输入生日时间');
                return;
            }
            // 检查输入:昵称:可以为空:为空时设置为未命名
            formData.f_name = formData.f_name != '' ? formData.f_name : '未命名';
            // 处理输入地址后的真太阳时参数
            if(formData.location != '') {
                formData.real_time = FORMAT.getRealSunTimeByData(formData.location, formData.birthday);
            }else {
                let {real_time, ...newFormData} = formData;
                formData = Object.assign({}, newFormData);
            }
            var rt = parseInt(this.$store.state.setting.settingConfigData.rt);
                formData['rt'] = rt;


            LOADING_DOM.showLoading();
            this.startLocked = true;
            this.$store.dispatch('strong/addReportBaziInfo', {
                params: formData,
                cb: (data) => {
                    console.log('添加测算成功::::::', data);
                    this.$store.dispatch('user/resetInputData');
                    this.$store.dispatch('report/resetReportData');
                    this.$store.dispatch('report/initReportAIConfig', {
                        cb: ()=> {
                            this.$store.dispatch('report/getReportInfo', {
                                detailInfo: data,
                                cb: (reportData)=> {
                                    console.log('获取测算信息成功::::::::', reportData);
                                    // 更新状态
                                    var params = {"aitips": 1};
                                    this.$store.dispatch('reminder/udpateExtList', {
                                        params: params
                                    });
                                    this.$store.dispatch('strong/getReportStrongInfo', {
                                        detailInfo: data,
                                        sucCb: ()=> {
                                            LOADING_DOM.hideLoading();
                                            this.startLocked = false;
                                            this.$router.replace('/generate/strong');
                                        }
                                    });
                                }
                            })
                        }
                    });
                }
            });
        },
    }
}
</script>